import React from 'react'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import 'styles/app/apps/widget-container.scss'

function WidgetContainer({
  subTitle,
  sideTitle,
  name,
  children,
  className = '',
}) {
  const defineTitle = title => {
    if (title instanceof Object) {
      return (
        <>
          <span className="title-start">{title.start}</span>
          <span className="title-end">{title.end}</span>
        </>
      )
    }

    return <span className="title-start">{title}</span>
  }

  return (
    <Paper className={`widget-item ${className}`}>
      <div className="widget-head">
        <Typography
          variant="h6"
          className="widget-title"
          gutterBottom={!sideTitle || subTitle}>
          {defineTitle(name)}
        </Typography>
        {subTitle && (
          <Typography variant="body1" className="widget-subTitle">
            {subTitle}
          </Typography>
        )}
        {sideTitle && (
          <Typography
            variant="body1"
            component="div"
            className="widget-sideTitle">
            {sideTitle}
          </Typography>
        )}
      </div>
      {children}
    </Paper>
  )
}

export default WidgetContainer
